export default "__VITE_ASSET__B6MI1UJ8__"